import { GradientStrategy } from "../../../../lib/layers/selectable/color/strategies";
export class RadialStrategy extends GradientStrategy {
    constructor() {
        super();
        this.name = "Radial";
    }
    generate_colors(color_range) {
        const start = this.hex2hsl(color_range.start);
        const end = this.hex2hsl(color_range.end);
        const interval = 1 / (color_range.steps - 1);
        let gradient = Array(color_range.steps);
        for (let i = 0; i < color_range.steps; i++) {
            gradient[i] = [
                Math.round(start[0] * (1 - i * interval) + end[0] * i * interval),
                Math.round(start[1] * (1 - i * interval) + end[1] * i * interval),
                Math.round(start[2] * (1 - i * interval) + end[2] * i * interval)
            ];
        }
        color_range.update_jenks(gradient.map(e => this.hsl2hex(e)));
        return gradient.map(e => this.hsl2hex(e));
    }
}
